
import AdditionalFees from '../../callouts/AdditionalFees.vue';
import ProductPrice from '../../ProductPrice.vue';
import { computed, defineComponent } from 'vue';
import { IProductDetailProductJson } from 'JS/types/PDP';
import { IProductPriceViewModel } from 'JS/types/Product';
import { PropType } from 'vue';

export default defineComponent({
	name: 'InstallationQuoteProduct',
	components: {
		AdditionalFees,
		ProductPrice,
	},
	props: {
		product: {
			type: Object as PropType<IProductDetailProductJson>,
			required: true,
		},
		price: {
			type: Object as PropType<IProductPriceViewModel>,
			required: true,
		}
	},
	setup(props) {
		return {
			hasAdditionalCharge: computed(() => !!props.product.additionalCharge?.hasAdditionalCharge),
		};
	}
});
